export function hmrPropertyFactory(scope: string) {
  return (customPropertyName?: string) => hmr(scope, customPropertyName);
}

export function hmr(scope: string, customPropertyName?: string) {
  return function (_value: undefined, context: ClassFieldDecoratorContext) {
    const propertyName = customPropertyName ?? (context.name as string);

    return function inializer(this: any, value: any): any {
      if (import.meta.env.PROD || import.meta.env.SSR) {
        return value;
      }

      const dataKey = `${scope}-${propertyName}`;

      const data = import.meta.hot?.data;

      const initializedValue = data && dataKey in data ? data[dataKey] : value;

      if (import.meta.hot) {
        import.meta.hot.data[dataKey] = initializedValue;
      }

      return initializedValue;
    };
  };
}
